import React from 'react';
import { Container, Typography, Box } from '@mui/material';

function PrivacyPolicy() {
  return (
    <>
      <Container maxWidth="md">
        <Box sx={{ my: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Privacy Policy
          </Typography>
          <Typography variant="body1" paragraph>
            Your privacy is critically important to us. This policy outlines how we handle your personal information.
          </Typography>

          <Typography variant="h6" component="h2" gutterBottom>
            Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We only collect information essential for our service to function. When you sign in using a third-party service like Google/Facebook/Apple auth services, we might only receive your name and email address. We do not collect or store sensitive information like your mailing address, phone number, or credit card details.
          </Typography>

          <Typography variant="h6" component="h2" gutterBottom>
            How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            Your information is used strictly to provide and improve your experience on TrackCopr.
            <ul>
              <li><b>Service Functionality:</b> Your account allows you to create, follow, and manage timelines.</li>
              <li><b>Service Improvement:</b> We analyze usage data in an aggregated, anonymous form to understand user behavior and enhance our platform.</li>
              <li><b>Communication:</b> We will never use your email for marketing purposes. The only emails you will receive from us are essential service-related announcements.</li>
            </ul>
          </Typography>

          <Typography variant="h6" component="h2" gutterBottom>
            Privacy in Timelines
          </Typography>
          <Typography variant="body1" paragraph>
            <b>Submitting Timelines:</b> When you create a timeline, it is associated with your profile. Please be mindful that any personal information you voluntarily include in the "Notes" section will be visible to others.
          </Typography>
          <Typography variant="body1" paragraph>
            <b>Following Timelines:</b> When you follow a timeline, the creator is not notified. They cannot see who or how many people are following their timeline. Your following activity is completely private.
          </Typography>

          <Typography variant="h6" component="h2" gutterBottom>
            Sharing Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We do not sell, trade, or rent your personal information.
          </Typography>

          <Typography variant="h6" component="h2" gutterBottom>
            Account Deletion
          </Typography>
          <Typography variant="body1" paragraph>
            You can request to delete your account at any time from your profile page. Here’s how it works:
            <ol>
              <li>Your account is immediately scheduled for deletion, and you are logged out.</li>
              <li>You can still access your data during the 30-day grace period. After this period, your data is scheduled for permanent deletion. For security and to prevent accidental loss, we retain this data for a 30-day grace period.</li>
              <li>After 30 days, your account and all associated information will be permanently and irreversibly deleted from our systems.</li>
            </ol>
            {/* </ol> This is not implemented yet, but will be added in the future.
            You can cancel the deletion process by logging back into your account within the 30-day window. */}
          </Typography>

          <Typography variant="h6" component="h2" gutterBottom>
            Changes to This Privacy Policy
          </Typography>
          <Typography variant="body1" paragraph>
            TrackCopr has the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect.
          </Typography>

          <Typography variant="h6" component="h2" gutterBottom>
            Contacting Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us at admin@trackcopr.com.
          </Typography>

          <Typography variant="caption" display="block" sx={{ mt: 2 }}>
            This document was last updated on July 24, 2025.
          </Typography>
        </Box>
      </Container>
    </>
  );
}

export default PrivacyPolicy;